import { render, staticRenderFns } from "./BooleanAsIcon.vue?vue&type=template&id=a6e93802&"
import script from "./BooleanAsIcon.vue?vue&type=script&lang=js&"
export * from "./BooleanAsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports